module.exports = require("./../../_gen/starling/rendering/Effect");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/Effect.js
// module id = 212
// module chunks = 0